import { gql } from "@apollo/client";

export const checkPasswordRecoveryRequestQuery = gql`
  query CheckPasswordRecoveryRequest($uuid: String!) {
    checkRecoverPasswordRequest(uuid: $uuid)
  }
`;

export const recoverPasswordAfterRequestMutation = gql`
  mutation recoverPasswordAfterRequest($uuid: String!, $newPassword: String!) {
    recoverPasswordAfterRequest(uuid: $uuid, newPassword: $newPassword) {
      user {
        id
        email
        disabled
        name
        permissions
      }
      authToken
    }
  }
`;
